import { render, staticRenderFns } from "./PayoutsPaid.vue?vue&type=template&id=1380a86f&scoped=true&"
import script from "./PayoutsPaid.vue?vue&type=script&lang=js&"
export * from "./PayoutsPaid.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsPaid.vue?vue&type=style&index=0&id=1380a86f&lang=scss&scoped=true&"
import style1 from "./PayoutsPaid.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380a86f",
  null
  
)

export default component.exports